const now = 'Last updated · January 2026';

export const POLICIES = {
  privacy: {
    title: 'Privacy Policy',
    eyebrow: 'Your data, considered',
    updated: now,
    sections: [
      { h: 'What we collect', p: 'When you shop with Evermark we collect only what we need: your name, delivery address, email, and payment details (processed by our payment partner, never stored by us). Wishlist and cart contents live on your device.' },
      { h: 'How we use it', p: 'To fulfill your order, keep you updated on its progress, and — with your permission — send you occasional letters from the studio. We never sell your data.' },
      { h: 'Third parties', p: 'We share the minimum necessary with logistics, payment, and analytics partners bound by contract to protect your data. A full list is available on request.' },
      { h: 'Your rights', p: 'You may request a copy, correction, or deletion of your personal data at any time by writing to privacy@evermark.com.' },
      { h: 'Contact', p: 'Questions? Reach us at privacy@evermark.com.' },
    ],
  },
  terms: {
    title: 'Terms of Service',
    eyebrow: 'The fine print, plainly',
    updated: now,
    sections: [
      { h: 'Ordering', p: 'Placing an order is an offer to purchase. We reserve the right to decline or cancel any order in the case of pricing errors, stock issues, or suspected fraud.' },
      { h: 'Prices & currency', p: 'All prices are listed in US dollars unless otherwise indicated. Applicable taxes and duties are calculated at checkout.' },
      { h: 'Intellectual property', p: 'All content on this site — photography, copy, product designs, and the Evermark mark — is the property of Evermark and may not be reproduced without written consent.' },
      { h: 'Limitation of liability', p: 'To the fullest extent permitted by law, Evermark shall not be liable for indirect, incidental, or consequential damages arising from the use of this site or its products.' },
      { h: 'Governing law', p: 'These terms are governed by the laws of the State of New York. Any disputes will be resolved in the courts of New York County.' },
    ],
  },
  shipping: {
    title: 'Shipping',
    eyebrow: 'On its way',
    updated: now,
    sections: [
      { h: 'Rates', p: 'Standard shipping is complimentary on orders over $150 within the United States and $300 internationally. Below those thresholds a flat rate of $12 (US) or $28 (international) applies.' },
      { h: 'Processing time', p: 'In-stock orders placed before 12pm ET dispatch the same business day. Made-to-order and bespoke pieces ship in 2–3 weeks.' },
      { h: 'Tracking', p: 'A tracking link is emailed the moment your order leaves our atelier. Expect delivery in 2–5 business days (US) or 5–10 (international).' },
      { h: 'Duties & taxes', p: 'All duties and taxes are calculated and paid at checkout so nothing is due on delivery.' },
      { h: 'Atelier pick-up', p: 'Select "Atelier pick-up" at checkout and choose New York, Kyoto, or Copenhagen. Your order will be waiting within one business day.' },
    ],
  },
  returns: {
    title: 'Returns',
    eyebrow: 'If it isn\'t right',
    updated: now,
    sections: [
      { h: 'Window', p: 'Unworn pieces with original tags may be returned for a full refund within 30 days of delivery. Sale pieces are eligible for exchange or store credit within 14 days.' },
      { h: 'How to return', p: 'Write to hello@evermark.com with your order number. We\'ll email you a prepaid return label and next steps within one business day.' },
      { h: 'Refunds', p: 'Refunds are issued to the original payment method within 5 business days of receipt at our warehouse.' },
      { h: 'Exchanges', p: 'Prefer a different size or colour? Note it in your return request and we\'ll ship the replacement as soon as your return is on its way — no waiting.' },
      { h: 'Repair & care', p: 'For the life of the garment we offer small repairs at our workshop. Complimentary hemming in the first year.' },
    ],
  },
  cookies: {
    title: 'Cookies',
    eyebrow: 'Small, but noted',
    updated: now,
    sections: [
      { h: 'What are cookies', p: 'Cookies are small pieces of information stored by your browser. They help websites remember your preferences and understand how you use them.' },
      { h: 'How we use them', p: 'We use essential cookies to keep your cart and wishlist between visits, and analytics cookies (with your permission) to understand which pieces resonate most.' },
      { h: 'Managing cookies', p: 'You may adjust or disable cookies at any time in your browser settings. Note that some parts of the site — namely cart and wishlist — rely on essential cookies to function.' },
      { h: 'Contact', p: 'Questions about our use of cookies? Write to privacy@evermark.com.' },
    ],
  },
};
